import { createSlice } from "@reduxjs/toolkit";
import { Address, BankAccount, Relationship, SubscriptionInfo } from "../@types/subscriptionInfo";



export interface IAssociateState {
    subscriptionInfo?: SubscriptionInfo
    address?: Address,
    relationships: Relationship[],
    bankAccount?: BankAccount,
    editingElementPosition?: number
}

const initialState: IAssociateState = {
    relationships: []
}

const associateSlice = createSlice({
    name: "associateSlice",
    initialState: initialState,
    reducers: {
        reset(state) {
            state = initialState;
            return state;
        },
        addSubscriptionInfo(state, action) {
            state.subscriptionInfo = action.payload;
            state.relationships = action.payload.ownerPerson.relationships
            return state;
        },
        addAddress(state, action) {
            const address = action.payload as Address;
            state.address = address;
            return state;
        },
        addRelationship(state, action) {
            const relationship = action.payload as Relationship;
            if (state.editingElementPosition !== undefined && state.relationships.length) {
                state.relationships[state.editingElementPosition] = relationship
                return state
            }
            state.relationships.push(relationship)
            return state;
        },
        removeRelationship(state, action) {
            const index = action.payload;
            state.relationships.splice(index, 1)
            return state;
        },
        addBank(state, action) {
            const bankAccount = action.payload as BankAccount;

            state.bankAccount = bankAccount;

            return state;
        },
        setEditingElementPosition(state, action) {
            const index = action.payload;
            state.editingElementPosition = index
            return state;
        },
        resetEditingElementPosition(state) {
            state.editingElementPosition = undefined
            return state;
        },
    },
});

export const { addAddress, addSubscriptionInfo, reset, addRelationship, removeRelationship, addBank, setEditingElementPosition, resetEditingElementPosition } = associateSlice.actions;
export default associateSlice.reducer;